import loadable from '@loadable/component';

export default {
	simple: loadable(() => import('/views/layouts/simple')),
	raw: loadable(() => import('/views/layouts/raw')),
};
